import sp from "../../../assets/images/Footer/sp.svg";
import st4 from "../../../assets/images/NewEvent/st4.webp";

import sukien1 from "../../../assets/images/NewEvent/sukien1.webp";

import "swiper/css";
import "swiper/css/navigation";

export default function ConferenceEvent() {
  const profiles = [
    { src: st4 },
    {
      src: st4,
    },
    {
      src: st4,
    },
    {
      src: st4,
    },
  ];
  return (
    <div className="w-full bg-[#f1f5ff]">
      <div className="w-full container mx-auto px-[20px] py-[50px] flex flex-col gap-3">
        <div className="flex flex-col gap-2 py-2">
          <div className="flex items-center gap-1 justify-center">
            <img src={sp} alt="bg" className="hidden md:block" />
            <p className="md:text-[32px] text-[26px] text-[#053CC8] font-semibold">
              SỰ KIỆN & HỘI THẢO
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center">
          {/* <div className="w-full grid grid-cols-1 md:flex md:gap-3 gap-4">
            <div className="w-full md:w-9/12">
              <img
                src={Left1}
                alt="le1"
                className="w-full h-96 object-cover rounded-md"
              />
            </div>
            <div className="w-full md:w-3/12 h-96 md:h-96 ">
              <div className="scroll-container flex flex-col gap-3 md:gap-6 w-full md:overflow-x-hidden overflow-x-hidden">
                <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                  <img
                    src={stttt}
                    alt="st3"
                    className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                  />
                  <div>
                    <p className="block md:hidden w-full h-[116px] text-[13px]">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Aliquam cursus nulla vitae massa gravida, id fringilla
                      arcu rhoncus.{" "}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                  <img
                    src={stttt}
                    alt="st4"
                    className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                  />
                  <div>
                    <p className="block md:hidden w-full h-[116px] text-[13px]">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Aliquam cursus nulla vitae massa gravida, id fringilla
                      arcu rhoncus.{" "}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                  <img
                    src={stttt}
                    alt="st5"
                    className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                  />
                  <div>
                    <p className="block md:hidden w-full h-[116px] text-[13px]">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Aliquam cursus nulla vitae massa gravida, id fringilla
                      arcu rhoncus.{" "}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                  <img
                    src={stttt}
                    alt="st6"
                    className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                  />
                  <div>
                    <p className="block md:hidden w-full h-[116px] text-[13px]">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Aliquam cursus nulla vitae massa gravida, id fringilla
                      arcu rhoncus.{" "}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                  <img
                    src={stttt}
                    alt="st7"
                    className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                  />
                  <div>
                    <p className="block md:hidden w-full h-[116px] text-[13px]">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Aliquam cursus nulla vitae massa gravida, id fringilla
                      arcu rhoncus.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <img
            src={sukien1}
            alt="sk1"
            className="rounded-md w-full h-auto shadow-md"
          />
        </div>
      </div>
    </div>
  );
}
